import { Injectable } from '@angular/core';
import { BaseRepositoryService } from './base.service';
import { Entity } from '../model/entity.model';
import { doc, setDoc } from 'firebase/firestore';

@Injectable({
  providedIn: 'root'
})
export class OotbEntityService extends BaseRepositoryService<Entity>{
  override collectionPath: string = '/ootbEntity';
  constructor() { 
    super();
  }
}





// TODO : prompt for generating the json
// here is a json of the definition of the object - 
// {
//     "name": "hello",
//     "roles": [
//         {
//             "id": "NzM3MT_admin",
//             "name": "admin"
//         }
//     ],
//     "type": "TABLE",
//     "id": "hello_MTAyMT",
//     "status": "NEW",
//     "data": [
//         {
//             "name": "id",
//             "data": [],
//             "referenceEntityColumnName": "id",
//             "type": "UUID",
//             "id": "",
//             "primaryKey": true,
//             "isUnique": true,
//             "referenceEntityName": "",
//             "startIncrementFrom": 0
//         },
//         {
//             "startIncrementFrom": 0,
//             "data": [],
//             "isUnique": true,
//             "name": "id_auto_increment",
//             "primaryKey": false,
//             "referenceEntityName": "",
//             "referenceEntityColumnName": "id",
//             "id": "",
//             "type": "AUTO_INCREMENT"
//         },
//         {
//             "referenceEntityColumnName": "id",
//             "startIncrementFrom": 0,
//             "isUnique": false,
//             "data": [],
//             "referenceEntityName": "",
//             "id": "asd_MTE2MT",
//             "primaryKey": false,
//             "type": "NUMBER",
//             "name": "asd"
//         },
//         {
//             "startIncrementFrom": 0,
//             "isUnique": false,
//             "referenceEntityColumnName": "id",
//             "id": "AAA_ODc0Mz",
//             "name": "AAA",
//             "data": [
//                 {
//                     "primaryKey": true,
//                     "type": "UUID",
//                     "id": "",
//                     "referenceEntityColumnName": "id",
//                     "referenceEntityName": "",
//                     "startIncrementFrom": 0,
//                     "name": "id",
//                     "data": [],
//                     "isUnique": true
//                 },
//                 {
//                     "referenceEntityColumnName": "id",
//                     "name": "id_auto_increment",
//                     "id": "",
//                     "type": "AUTO_INCREMENT",
//                     "isUnique": true,
//                     "startIncrementFrom": 0,
//                     "referenceEntityName": "",
//                     "primaryKey": false,
//                     "data": []
//                 },
//                 {
//                     "referenceEntityName": "hello_MTAyMT",
//                     "id": "",
//                     "primaryKey": false,
//                     "startIncrementFrom": 0,
//                     "isUnique": true,
//                     "name": "parent_id",
//                     "data": [],
//                     "referenceEntityColumnName": "id",
//                     "type": "ENTITY_REFERENCE"
//                 },
//                 {
//                     "startIncrementFrom": 0,
//                     "isUnique": false,
//                     "type": "NUMBER",
//                     "referenceEntityName": "",
//                     "name": "FFDSD",
//                     "referenceEntityColumnName": "id",
//                     "id": "FFDSD_Nzg2OT",
//                     "primaryKey": false,
//                     "data": []
//                 }
//             ],
//             "type": "ARRAY_OF_OBJECT",
//             "primaryKey": false,
//             "referenceEntityName": ""
//         }
//     ]
// }

// the supported data types are   dataTypes = [
//     'STRING',
//     'NUMBER',
//     'BOOLEAN',
//     'ARRAY_OF_OBJECT',
//     'AUTO_INCREMENT',
//     'ENTITY_REFERENCE',
//   ];
// only ARRAY_OF_OBJECTS has a nested structure 
// I want you to create the same definition for a json example - 

// {
// 	"ewbNo": 381009282489,
// 	"ewayBillDate": "20/02/2024 04:19:00 PM",
// 	"genMode": "API",
// 	"userGstin": "05AAACH6188F1ZM",
// 	"supplyType": "O",
// 	"subSupplyType": "1  ",
// 	"docType": "INV",
// 	"docNo": "sumitra/06/2020",
// 	"docDate": "20/02/2024",
// 	"fromGstin": "05AAACH6188F1ZM",
// 	"fromTrdName": "welton",
// 	"fromAddr1": "2ND CROSS NO 59  19  A",
// 	"fromAddr2": "GROUND FLOOR OSBORNE ROAD",
// 	"fromPlace": "FRAZER TOWN",
// 	"fromPincode": 263652,
// 	"fromStateCode": 5,
// 	"toGstin": "05AAACH6886N1Z0",
// 	"toTrdName": "sthuthya",
// 	"toAddr1": "Shree Nilaya",
// 	"toAddr2": "Dasarahosahalli",
// 	"toPlace": "Beml Nagar",
// 	"toPincode": 176036,
// 	"toStateCode": 2,
// 	"totalValue": 56099,
// 	"totInvValue": 57200.23,
// 	"cgstValue": 0,
// 	"sgstValue": 0,
// 	"igstValue": 300.67,
// 	"cessValue": 400.56,
// 	"transporterId": "05AAACG0904A1ZL",
// 	"transporterName": "M/S GSBA BUILDERS PVT LTD",
// 	"status": "CNL",
// 	"actualDist": 772,
// 	"noValidDays": 4,
// 	"validUpto": "24/02/2024 11:59:00 PM",
// 	"extendedTimes": 0,
// 	"rejectStatus": "N",
// 	"vehicleType": "R",
// 	"actFromStateCode": 5,
// 	"actToStateCode": 2,
// 	"transactionType": 4,
// 	"otherValue": 0,
// 	"cessNonAdvolValue": 400,
// 	"itemList": [
// 		{
// 			"itemNo": 1,
// 			"productId": 0,
// 			"productName": "Wheat",
// 			"productDesc": "Wheat",
// 			"hsnCode": 1001,
// 			"quantity": 4,
// 			"qtyUnit": "BOX",
// 			"cgstRate": 0,
// 			"sgstRate": 0,
// 			"igstRate": 3,
// 			"cessRate": 0,
// 			"cessNonAdvol": 0,
// 			"taxableAmount": 56099
// 		}
// 	],
// 	"VehiclListDetails": [
// 		{
// 			"updMode": "API",
// 			"vehicleNo": "ABC1234",
// 			"fromPlace": "FRAZER TOWN",
// 			"fromState": 5,
// 			"tripshtNo": 0,
// 			"userGSTINTransin": "05AAACH6188F1ZM",
// 			"enteredDate": "20/02/2024 06:12:00 PM",
// 			"transMode": "1",
// 			"transDocNo": "sumitra/06/2020",
// 			"transDocDate": null,
// 			"groupNo": "1"
// 		},
// 		{
// 			"updMode": "API",
// 			"vehicleNo": "ABC1234",
// 			"fromPlace": "FRAZER TOWN",
// 			"fromState": 5,
// 			"tripshtNo": 0,
// 			"userGSTINTransin": "05AAACH6188F1ZM",
// 			"enteredDate": "20/02/2024 06:08:00 PM",
// 			"transMode": "1",
// 			"transDocNo": "12",
// 			"transDocDate": "20/02/2024",
// 			"groupNo": "1"
// 		},
// 		{
// 			"updMode": "API",
// 			"vehicleNo": "ABC1234",
// 			"fromPlace": "FRAZER TOWN",
// 			"fromState": 5,
// 			"tripshtNo": 3710009433,
// 			"userGSTINTransin": "05AAACH6188F1ZM",
// 			"enteredDate": "20/02/2024 05:46:00 PM",
// 			"transMode": "1",
// 			"transDocNo": "12",
// 			"transDocDate": "20/02/2024",
// 			"groupNo": "0"
// 		},
// 		{
// 			"updMode": "API",
// 			"vehicleNo": "ABC1234",
// 			"fromPlace": "FRAZER TOWN",
// 			"fromState": 5,
// 			"tripshtNo": 3010009432,
// 			"userGSTINTransin": "05AAACH6188F1ZM",
// 			"enteredDate": "20/02/2024 05:13:00 PM",
// 			"transMode": "1",
// 			"transDocNo": "12",
// 			"transDocDate": "20/02/2024",
// 			"groupNo": "0"
// 		},
// 		{
// 			"updMode": "API",
// 			"vehicleNo": "ABC1234",
// 			"fromPlace": "FRAZER TOWN",
// 			"fromState": 5,
// 			"tripshtNo": 0,
// 			"userGSTINTransin": "05AAACH6188F1ZM",
// 			"enteredDate": "20/02/2024 05:01:00 PM",
// 			"transMode": "1",
// 			"transDocNo": "12",
// 			"transDocDate": "20/02/2024",
// 			"groupNo": "0"
// 		},
// 		{
// 			"updMode": "API",
// 			"vehicleNo": "APR3214",
// 			"fromPlace": "FRAZER TOWN",
// 			"fromState": 5,
// 			"tripshtNo": 0,
// 			"userGSTINTransin": "05AAACH6188F1ZM",
// 			"enteredDate": "20/02/2024 04:19:00 PM",
// 			"transMode": "1",
// 			"transDocNo": "12",
// 			"transDocDate": null,
// 			"groupNo": "0"
// 		}
// 	]
// } 

//  please make sure that every property in the json is defined in the definition